import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";

// Lazy load non-critical pages for better LCP
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const ChiSono = lazy(() => import("./pages/ChiSono"));
const Prenota = lazy(() => import("./pages/Prenota"));
const Testimonianze = lazy(() => import("./pages/Testimonianze"));
const Setup = lazy(() => import("./pages/Setup"));

// Loading fallback component
function PageFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-pulse text-muted-foreground">Caricamento...</div>
    </div>
  );
}

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/blog"} component={() => (
        <Suspense fallback={<PageFallback />}>
          <Blog />
        </Suspense>
      )} />
      <Route path={"/blog/:slug"} component={({ params }) => (
        <Suspense fallback={<PageFallback />}>
          <BlogArticle slug={params.slug} />
        </Suspense>
      )} />
      <Route path={"/chi-sono"} component={() => (
        <Suspense fallback={<PageFallback />}>
          <ChiSono />
        </Suspense>
      )} />
      <Route path={"/prenota"} component={() => (
        <Suspense fallback={<PageFallback />}>
          <Prenota />
        </Suspense>
      )} />
      <Route path={"/testimonianze"} component={() => (
        <Suspense fallback={<PageFallback />}>
          <Testimonianze />
        </Suspense>
      )} />
      <Route path={"/setup"} component={() => (
        <Suspense fallback={<PageFallback />}>
          <Setup />
        </Suspense>
      )} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Helmet htmlAttributes={{ lang: "it" }} />
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
